function updateStats(mana, coins, gems) {
    document.getElementById('manaStat').textContent = `⭐️ ${mana}`;
    document.getElementById('coinsStat').textContent = `💰 ${coins}`;
    document.getElementById('gemsStat').textContent = `🔮 ${gems}`;
}

export { updateStats };
